/** "WE 01 · EG links" @param {{ id: number|string, number?: string|null, designation?: string|null }} unit */
export function unitTitle(unit) {
  return [unit.number, unit.designation].filter(Boolean).join(' · ') || `Einheit #${unit.id}`;
}
